import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { MarketingFooter } from '#app/components/marketing-footer.tsx'
import { MarketingHeader } from '#app/components/marketing-header.tsx'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '#app/components/ui/accordion.tsx'
import { Button } from '#app/components/ui/button.tsx'

export default function FAQ() {
  const { t, ready } = useTranslation(['marketing', 'common'])
  
  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
            <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          </div>
          <p className="text-lg text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }
  
  const faqs = t('marketing:faq.questions', { returnObjects: true }) as Array<{ q: string; a: string }>
  return (
    <div className="flex flex-col min-h-screen">
      <MarketingHeader />

      <main className="flex-1">
        {/* FAQ Section */}
        <section className="py-20">
          <div className="container max-w-3xl">
            <div className="text-center mb-12 space-y-4">
              <h1 className="text-4xl font-bold font-[family-name:var(--font-heading)]">{t('marketing:faq.title')}</h1>
              <p className="text-xl text-muted-foreground">
                {t('marketing:faq.subtitle')}
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent>
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            {/* CTA Section */}
            <div className="mt-16 text-center space-y-4 p-8 bg-muted rounded-lg">
              <h2 className="text-2xl font-bold font-[family-name:var(--font-heading)]">{t('marketing:faq.stillHaveQuestions')}</h2>
              <p className="text-muted-foreground">
                {t('marketing:faq.helpText')}
              </p>
              <div className="flex gap-4 justify-center">
                <Link to="/contact">
                  <Button variant="outline">{t('marketing:faq.contactUs')}</Button>
                </Link>
                <Link to="/signup">
                  <Button>{t('marketing:faq.startFree')}</Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <MarketingFooter />
    </div>
  )
}